import { StatusVariantColor } from '@/core/types/components/status';
import { ApproveStatus, EdiType } from '@/graphql/generated';

export const LEGAL_APPROVE_STATUS_MAP: Record<
  ApproveStatus,
  {
    name: string;
    color: StatusVariantColor;
  }
> = {
  [ApproveStatus.Approved]: {
    name: 'Активно',
    color: StatusVariantColor.Green,
  },
  [ApproveStatus.OnApproval]: {
    name: 'На рассмотрении',
    color: StatusVariantColor.Blue,
  },
  [ApproveStatus.Declined]: {
    name: 'Отклонено',
    color: StatusVariantColor.Red,
  },
};

export const EDI_TYPE_SELECT_ITEMS = [
  {
    value: EdiType.Extranet,
    name: 'Экстранет',
  },
  {
    value: EdiType.Other,
    name: 'Стороннее ЭДО',
  },
];
